import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export function createWiseConnection(): Promise<any> {
  return fetchWrapper(endpoint + '/v1/wise', {
    method: 'post',
  }).then((res) => res.json());
}

export function updateWiseConnection(params: { id: string; error?: string }) {
  const id = params.id;
  delete params.id;
  return fetchWrapper(endpoint + `/v1/wise/${id}`, {
    method: 'put',
    body: JSON.stringify(params),
  });
}

export function getWiseAccounts(id: string) {
  return fetchWrapper(endpoint + `/v1/wise/accounts/${id}`, {
    method: 'get',
  }).then((res) => res.json());
}
